import { DateTime as DateTime$1 } from "../../../../components/DateTime/index.js";
import { DATA_TYPE_LABELS } from "../constants.js";
import { DATA_TYPE_ICONS } from "../icons.js";
import { OccurrenceTrackLane } from "../occurrence/OccurrenceTrackLane.js";
import { formatOccurrenceTag } from "../format-occurrence-tag.js";
import { formatCompactStatusSummary } from "./status.js";
import { ActivityEvalStatusTag } from "./ActivityEvalStatusTag.js";
import { absoluteWindowAxis, parentRelativeWindowAxis } from "./absolute-window-axis.js";
import "react";
import { Icon, Tag } from "@therms/atalaya";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/ServicePeriods/activity-evals/instance/ActivityEvalInstanceDisplay.tsx
function ActivityEvalInstanceDisplay({ activityEval, periodEndsAt, periodStartsAt, timezone }) {
	const namePrefix = activityEval.window.name ? `${activityEval.window.name} · ` : "";
	const { status, statusSummary } = activityEval;
	const showAcceptStart = Boolean(activityEval.window.acceptStartsAt) && activityEval.window.acceptStartsAt !== activityEval.window.startsAt;
	const showAcceptEnd = Boolean(activityEval.window.acceptEndsAt) && activityEval.window.acceptEndsAt !== activityEval.window.endsAt;
	const trackAxis = periodStartsAt && periodEndsAt ? parentRelativeWindowAxis({
		endsAt: periodEndsAt,
		startsAt: periodStartsAt
	}, activityEval.window, timezone) : absoluteWindowAxis(activityEval.window, timezone);
	return /* @__PURE__ */ jsxs("div", {
		className: "gap-xxs flex flex-col",
		children: [
			/* @__PURE__ */ jsxs("div", {
				className: "gap-xs flex flex-wrap items-center",
				children: [
					/* @__PURE__ */ jsx(Icon, {
						Icon: DATA_TYPE_ICONS[activityEval.dataType],
						color: "main",
						size: "sm"
					}),
					/* @__PURE__ */ jsx("span", {
						className: "text-color-strong min-w-0 font-medium",
						children: DATA_TYPE_LABELS[activityEval.dataType]
					}),
					/* @__PURE__ */ jsx(Tag, {
						value: formatOccurrenceTag(activityEval.occurrence),
						variant: "info"
					}),
					/* @__PURE__ */ jsxs("div", {
						className: "gap-xs ml-auto flex shrink-0 items-center",
						children: [status !== void 0 && statusSummary !== void 0 ? /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsx(ActivityEvalStatusTag, { status }), /* @__PURE__ */ jsx("span", {
							className: "text-sm",
							children: formatCompactStatusSummary(statusSummary)
						})] }) : null, /* @__PURE__ */ jsxs("span", {
							className: "text-color-subtle text-sm",
							children: [
								namePrefix,
								/* @__PURE__ */ jsx(DateTime$1, {
									mode: "time",
									timestamp: activityEval.window.startsAt,
									timezone,
									toggleRelativeOnClick: false
								}),
								/* @__PURE__ */ jsx("span", {
									className: "px-xxs",
									children: "→"
								}),
								/* @__PURE__ */ jsx(DateTime$1, {
									mode: "time",
									timestamp: activityEval.window.endsAt,
									timezone,
									toggleRelativeOnClick: false
								})
							]
						})]
					})
				]
			}),
			showAcceptStart || showAcceptEnd ? /* @__PURE__ */ jsx("div", {
				className: "text-color-subtle text-sm",
				children: showAcceptStart && showAcceptEnd ? /* @__PURE__ */ jsxs(Fragment$1, { children: [
					"Accepts from",
					" ",
					/* @__PURE__ */ jsx(DateTime$1, {
						mode: "time",
						timestamp: activityEval.window.acceptStartsAt,
						timezone,
						toggleRelativeOnClick: false
					}),
					" until ",
					/* @__PURE__ */ jsx(DateTime$1, {
						mode: "time",
						timestamp: activityEval.window.acceptEndsAt,
						timezone,
						toggleRelativeOnClick: false
					})
				] }) : showAcceptStart ? /* @__PURE__ */ jsxs(Fragment$1, { children: [
					"Accepts from",
					" ",
					/* @__PURE__ */ jsx(DateTime$1, {
						mode: "time",
						timestamp: activityEval.window.acceptStartsAt,
						timezone,
						toggleRelativeOnClick: false
					})
				] }) : /* @__PURE__ */ jsxs(Fragment$1, { children: [
					"Accepts until",
					" ",
					/* @__PURE__ */ jsx(DateTime$1, {
						mode: "time",
						timestamp: activityEval.window.acceptEndsAt,
						timezone,
						toggleRelativeOnClick: false
					})
				] })
			}) : null,
			/* @__PURE__ */ jsx(OccurrenceTrackLane, {
				occurrence: activityEval.occurrence,
				periodDurationMin: trackAxis.periodDurationMin,
				periodFromMin: trackAxis.periodFromMin,
				periodToMin: trackAxis.periodToMin,
				relativeDurationMinutes: trackAxis.relativeDurationMinutes,
				relativeFromStartMinutes: trackAxis.relativeFromStartMinutes,
				segments: trackAxis.segments
			})
		]
	});
}
//#endregion
export { ActivityEvalInstanceDisplay };

//# sourceMappingURL=ActivityEvalInstanceDisplay.js.map